export const Fn = {
  // Valida el rut con su cadena completa "XXXXXXXX-X"
  validaRut: function (rutCompleto) {
    rutCompleto = rutCompleto.replace('‐', '-').replace(/[.]+/g, '')
    if (!/^\d+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false
    const tmp = rutCompleto.split('-')
    let digv = tmp[1]
    const rut = tmp[0]
    if (digv == 'K') digv = 'k'

    return Fn.dv(rut) == digv
  },
  dv: function (T) {
    let M = 0,
      S = 1
    for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11
    return S ? S - 1 : 'k'
  },
}

export const cleanRut = (value) => `${value ?? ''}`.replace(/[^0-9kK]/gi, '')
export const isNoNominative = (value) => /nn/i.test(`${value ?? ''}`)
export const isValidRut = (value) => {
  const clean = cleanRut(value)
  if (clean.length < 2) return false
  const body = clean.slice(0, -1)
  const dv = clean.slice(-1)
  return Fn.validaRut(`${body}-${dv}`)
}

export const normalizeText = (value) =>
  `${value ?? ''}`
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')

export const findInOptions = (value, options = []) => {
  const target = normalizeText(value)
  if (!target) return undefined
  return options.find((option) => normalizeText(option?.label) === target)
}

export const existsInOptions = (value, options = []) =>
  Boolean(findInOptions(value, options))

export const emailValidation = (value) => {
  let error
  if (!value) {
    error = 'Correo es requerido'
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = 'Correo invalido'
  }
  return error
}
